import { render, staticRenderFns } from "./CategoryCardState.vue?vue&type=template&id=255506e4&scoped=true"
import script from "./CategoryCardState.vue?vue&type=script&lang=ts"
export * from "./CategoryCardState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255506e4",
  null
  
)

export default component.exports